import GlobalStyle from './style';
import CryptoFontCSS from './cryptofont';

export { GlobalStyle, CryptoFontCSS };
